// extracted by mini-css-extract-plugin
module.exports = {"PromoCodeContainer":"PromoCodeContainer__PromoCodeContainer___3_mil"};